export default __webpack_public_path__ + "static/apt_vis_640-9d4e0fedf987bcea2a04708ebb54028a.mp4";